import React, { useState } from "react";
import styled from "styled-components";
import IntermarketChart from "./IntermarketChart";
import CurrencyStrengthTab from "./CurrencyStrengthTab";
import AssetCorrelationTab from "./AssetCorrelationTab";
import {
    ContentHeader,
    ContentTitleBlock,
    Chip,
    Subtitle,
    TabsNav,
    Tab,
    ContentActionsRow,
    BtnIcon
} from "../../components/SharedPageStyles";
import { SECTIONS } from "../../constants/sections";
import { useMarketOverviewData } from "../../context/MarketOverviewContext";

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0px;
    flex: 1;
    min-height: 0;
`;


const IntermarketPage = () => {
    const [activeTab, setActiveTab] = useState(SECTIONS["intermarket"].tabs[0].key);
    const [refreshKey, setRefreshKey] = useState(0);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const { resetData, isLoading } = useMarketOverviewData();

    const handleRefresh = async () => {
        setIsRefreshing(true);
        setRefreshKey(prev => prev + 1);
        if (resetData) resetData();
        setTimeout(() => setIsRefreshing(false), 600);
    };

    const renderContent = () => {
        switch (activeTab) {
            case "currency-strength":
                return <CurrencyStrengthTab key={refreshKey} />;
            case "asset-correlation":
                return <AssetCorrelationTab key={refreshKey} />;
            case "cross-sectors":
            case "cross-assets":
            default:
                return <IntermarketChart key={`${activeTab}-${refreshKey}`} mode={activeTab} />;
        }
    };

    return (
        <PageContainer>
            <ContentHeader>
                <ContentTitleBlock>
                    <Chip>Intermarket</Chip>
                    <Subtitle><em>Macro performance snapshot across asset classes and currencies.</em></Subtitle>
                </ContentTitleBlock>
            </ContentHeader>

            <ContentActionsRow style={{ marginTop: '18px' }}>
                <BtnIcon
                    aria-label="Refresh data"
                    onClick={handleRefresh}
                    title="Refresh data"
                    disabled={isLoading || isRefreshing}
                    $spinning={isLoading || isRefreshing}
                >
                    ⟳
                </BtnIcon>
            </ContentActionsRow>

            {/* Spacer to adjust tabs vertical position */}
            <div style={{ minHeight: '24px', flexShrink: 0 }}></div>

            <TabsNav>
                {SECTIONS["intermarket"].tabs.map(tab => (
                    <Tab
                        key={tab.key}
                        active={activeTab === tab.key}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </Tab>
                ))}
            </TabsNav>

            <div style={{ marginTop: '20px', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {renderContent()}
            </div>
        </PageContainer>
    );
};

export default IntermarketPage;

